window['social_networks#index'] = function () {
  $('input.social-network-active-switch').on('change', function () {
    const active = $(this).prop('checked')
    const id = $(this).val()
    const forEntity = $(this).attr('data-entity')

    $.ajax({
      url: `/social_networks/${id}/switch_activity`,
      type: 'PUT',
      data: { active, for_entity: forEntity }
    })
  })
}
